export const tipoContaOptions = [
  { value: 'C', label: 'Corrente' },
  { value: 'P', label: 'Poupança' },
];
